import "./App.css";
// import Todo from "./components/Todo";
import Todo from "./components/Main";

function App() {
  return (
    <div className="App">
      <Todo />
    </div>
  );
}

export default App;
